import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';

const styles = StyleSheet.create({
  headerContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 16,
    paddingHorizontal: 16,
  },
  header: {
    margin: 0,
  },
  subText: {
    fontWeight: 'normal',
  },
});

export const HeaderContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.headerContainer, style] });

export const Header = withTypography({
  variant: 'headerThree',
  fontSize: '3xl',
  lineHeight: 'md',
  style: styles.header,
});

export const SubText = withTypography({
  textAlign: 'center',
  fontSize: 'md',
  my: '$2',
  style: styles.subText,
});
